/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The phase of a single format conversion.
 */
export enum ImageExportFormatPhase {
  ImageExportFormatPhaseQueued = 'queued',
  ImageExportFormatPhaseConverting = 'converting',
  ImageExportFormatPhasePushing = 'pushing',
  ImageExportFormatPhaseComplete = 'complete',
  ImageExportFormatPhaseFailed = 'failed',
}
